import { render, staticRenderFns } from "./index.vue?vue&type=template&id=34ce493b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ce493b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34ce493b')) {
      api.createRecord('34ce493b', component.options)
    } else {
      api.reload('34ce493b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=34ce493b&scoped=true&", function () {
      api.rerender('34ce493b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormItem/TNumber/index.vue"
export default component.exports